import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/auth/AuthProvider';

export const PrivateRoute = () => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return <div>Carregando...</div>;
    }

    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};
